export default __webpack_public_path__ + "static/media/PH-course certificate.3b7d3bc1.png";